module.exports = __webpack_public_path__ + "img/ESFP.0cf39c0f.png";